import React from 'react';
import { routes } from 'constants/config';

const BlankSlateIcon = ({ name, src }) => (
  <div
    className="NewBlankSlate-icon"
    style={{
      backgroundImage: `url(${
        src || `${routes.ASSETS_BLANK_SLATES}/${name}.svg`
      })`,
    }}
  />
);

export default BlankSlateIcon;
